import { ChevronDown } from "lucide-react";
import { some } from "lodash";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { cn } from "@/app/_utils/cn";

export default function NavigationCollapseable({
  menuItem,
  toggle,
  selectedIndex,
  onNavigate,
}: {
  menuItem: any;
  toggle?: Function;
  selectedIndex: any;
  onNavigate?: () => void;
}) {
  const match = some(menuItem.children, (it) => {
    return !!selectedIndex?.match(`/admin${menuItem.link}${it.link}`);
  });
  const [open, setOpen] = useState(!!match);
  const navigate = useNavigate();
  const Icon = menuItem.icon;

  return (
    <div className="flex flex-col">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2.5 rounded-md px-2.5 py-2 text-[13.5px] font-medium text-muted-foreground hover:bg-muted hover:text-foreground"
      >
        <Icon className="size-4 flex-none" />
        <span className="flex-1 truncate text-left">{menuItem.label}</span>
        <ChevronDown
          className={cn(
            "size-3.5 flex-none transition-transform duration-200",
            open ? "rotate-180" : "rotate-0"
          )}
        />
      </button>
      {open && (
        <div className="mt-1 flex flex-col gap-px">
          {menuItem.children.map((child: any, index: number) => {
            const fullChildPath = `/admin${menuItem.link}${child.link}`;
            const childMatch = selectedIndex?.match(fullChildPath);

            return (
              <button
                key={index}
                type="button"
                onClick={() => {
                  toggle && toggle();
                  navigate(fullChildPath);
                  onNavigate?.();
                }}
                className={cn(
                  "flex items-center gap-2 py-1.5 pl-6 pr-2 text-left text-[13px]",
                  childMatch
                    ? "font-semibold text-foreground"
                    : "text-muted-foreground hover:text-foreground"
                )}
              >
                <span
                  className={cn(
                    "h-4 w-px flex-none",
                    childMatch ? "bg-primary" : "bg-border"
                  )}
                />
                <span className="truncate">{child.title}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
